import SalesTable from "./salesTable/SalesTable";
import SalesDetails from "./salesDetails/SalesDetails";

export { SalesTable, SalesDetails };



// WEBPACK FOOTER //
// ./src/components/sales/index.js